import React, { Component, Fragment } from 'react';

import { Box, Callout, Flex, Heading, Text } from 'core/components';
import { Field, RadioGroup, Select } from 'core/form';

export default class GuidedModeBehavior extends Component {
  onParametricModeChange = (field, value) => {
    const { form } = this.props;
    if (value === 'ignore') {
      form.getField('parametric_overrides.filterField').setOptions();
      form.getField('parametric_overrides.operator').setOptions();
    }
    form.getField('parametric_overrides.filterField').setRules(value !== 'ignore' ? 'required' : '');
    form.getField('parametric_overrides.operator').setRules(value !== 'ignore' ? 'required' : '');
  };

  onParametricFieldChange = (field, value) => {
    const { form, queryFilters } = this.props;
    const operators = queryFilters.operators[value] || queryFilters.standardFilterOperators;
    const parametricOperatorField = form.getField('parametric_overrides.operator');

    if (!(parametricOperatorField.getValue() in operators)) {
      parametricOperatorField.setValue(Object.keys(operators)[0]);
    }
  };

  render() {
    const {
      form,
      availableFiltersConfig,
      parametric_mode,
      filterOperatorOptions,
      standardFilterOperators,
      boxProps = { p: 2 },
      fieldBoxProps = { ml: 3, mt: 2 },
      disabled
    } = this.props;

    const parametricFilterField =
      form.getValue('parametric_overrides.filterField') || availableFiltersConfig.availableFilters[0];
    const parametricOperatorOptions = filterOperatorOptions[parametricFilterField] || standardFilterOperators;

    return (
      <Flex flexDirection="column" className="overflow-auto" flexAuto {...boxProps}>
        <Heading level={6}>Panel Guided Mode Behavior</Heading>

        <Text muted>Select the effect you want the user&apos;s input to have on this panel</Text>
        <Box {...fieldBoxProps}>
          <Field
            name="parametric_mode"
            className="no-margin"
            onChange={this.onParametricModeChange}
            labelStyle={{ textTransform: 'none' }}
            showLabel={false}
            disabled={disabled}
          >
            <RadioGroup
              inline={false}
              disabledOptions={!availableFiltersConfig.canOverrideSpecific ? ['override_specific'] : []}
            />
          </Field>
        </Box>

        {parametric_mode !== 'ignore' && (
          <Callout p={2} mt={2}>
            {parametric_mode === 'override_all' && <p>Ignore panels existing filters and add a new filter group:</p>}
            {parametric_mode === 'override_specific' && <p>Overriding all existing filters that contain:</p>}
            {parametric_mode === 'add_group' && <p>Add a new filter group:</p>}
            <Fragment>
              <Field
                name="parametric_overrides.filterField"
                disabled={disabled}
                options={availableFiltersConfig.availableFilters}
                onChange={this.onParametricFieldChange}
              >
                <Select menuWidth={350} />
              </Field>
              {(parametric_mode === 'override_all' || parametric_mode === 'add_group') && (
                <Field
                  name="parametric_overrides.operator"
                  className="no-margin"
                  disabled={disabled}
                  options={parametricOperatorOptions}
                >
                  <Select menuWidth={350} />
                </Field>
              )}
            </Fragment>
          </Callout>
        )}
      </Flex>
    );
  }
}
